(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
     
  document.documentElement.style.setProperty(
    '--announcement-bar-height',
    document.getElementById('shopify-section-announcement').offsetHeight + 'px',
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').offsetHeight + 'px');

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (window.pageYOffset != 0) {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-announcement').offsetHeight + 'px');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop != 0) {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-announcement').offsetHeight + 'px');
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    

  (function() {
    class NewsletterPopup extends HTMLElement {
      constructor() {
        super();
        this.delay = parseInt(this.dataset.delay) * 1000;
        this.hideOnCollections = this.dataset.hideOnCollections === 'true';
        this.hideOnProducts = this.dataset.hideOnProducts === 'true';
        this.hasBeenShown = localStorage.getItem('newsletter-popup-{{ section.id }}-shown') === 'true';
        this.hasSubscribed = localStorage.getItem('newsletter-popup-{{ section.id }}-subscribed') === 'true';
      }

      connectedCallback() {
        if (this.shouldShow()) {
          this.setupEventListeners();
          this.scheduleShow();
        }
      }

      shouldShow() {
        if (this.hasBeenShown || this.hasSubscribed) {
          return false;
        }

        const currentTemplate = document.body.classList;
        
        if (this.hideOnCollections && (currentTemplate.contains('template-collection') || currentTemplate.contains('template-list-collections'))) {
          return false;
        }

        if (this.hideOnProducts && currentTemplate.contains('template-product')) {
          return false;
        }

        return true;
      }

      setupEventListeners() {
        const closeButton = this.querySelector('.ai-newsletter-popup-close');
        const form = this.querySelector('form');
        const overlay = this;

        if(closeButton) closeButton.addEventListener('click', () => {
          this.hidePopup();
        });

        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) {
            this.hidePopup();
          }
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.classList.contains('active')) {
            this.hidePopup();
          }
        });

        if (form) form.addEventListener('submit', () => {
          setTimeout(() => {
            localStorage.setItem('newsletter-popup-{{ section.id }}-subscribed', 'true');
            setTimeout(() => {
              this.hidePopup();
            }, 2000);
          }, 100);
        });
      }

      scheduleShow() {
        setTimeout(() => {
          this.showPopup();
        }, this.delay);
      }

      showPopup() {
        this.classList.add('active');
        document.body.style.overflow = 'hidden';
        localStorage.setItem('newsletter-popup-{{ section.id }}-shown', 'true');
      }

      hidePopup() {
        this.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    customElements.define('newsletter-popup', NewsletterPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
